import { createSelector } from 'reselect';
import { subselect } from './root';

const userRankingSelector = createSelector(
  [(trivia) => trivia.position, (trivia) => trivia.totalPositions],
  (position, of) => ({
    position,
    of,
  }),
);

export const triviaUserRankingSelector = subselect(userRankingSelector);
